import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import { LAWYER_LA_STATUS_MILESTONES, ADVICE_BANK, PENDING_APPOINTMENT, LAWYER_SPA_STATUS_MILESTONES, SPA_SIGNED_PENDING, SOLD, TYPE_CASE_SPA, TYPE_CASE_LA } from '../../constants/lawyerCaseStatuses';
import { TRANSLATION_FILES } from '../../constants/translation';

class CaseStatusMilestone extends Component {
  static propTypes = {
    type: PropTypes.string,
    status: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    statusUpdatedAt: PropTypes.arrayOf(PropTypes.string),
  }
  static defaultProps = {
    type: TYPE_CASE_SPA,
    status: PENDING_APPOINTMENT,
    statusUpdatedAt: [],
  }
  getClassName = (item, idx, currentIndex) => {
    const classNames = ['status'];
    if (idx <= currentIndex) {
      classNames.push('active');
    }
    if (this.checkCurrent(item, idx, currentIndex)) {
      classNames.push('current');
    }
    return classNames.join(' ');
  }
  getCurrentIndex = () => {
    const { status, type } = this.props;
    if (type === TYPE_CASE_SPA) {
      return LAWYER_SPA_STATUS_MILESTONES.findIndex(s => (status === SPA_SIGNED_PENDING ? s.value === PENDING_APPOINTMENT : s.value === status));
    }
    return LAWYER_LA_STATUS_MILESTONES.findIndex(s => s.value === status);
  }
  checkCurrent = (item, idx, currentIndex) => {
    const defaultCheck = idx === currentIndex;
    const { type } = this.props;
    let extraCheck = item.value !== SOLD;
    if (type === TYPE_CASE_LA) {
      extraCheck = item.value !== ADVICE_BANK;
    }
    return defaultCheck && extraCheck;
  }
  renderDate = (idx) => {
    const { type, createdAt, statusUpdatedAt } = this.props;
    const dateFormat = 'DD-MM-YYYY, hh:mm a';
    if (idx === 0) {
      return <p className="date">{moment(createdAt).format(dateFormat)}</p>;
    }
    const dateIndex = idx - (type === TYPE_CASE_SPA ? 0 : 1);
    if (dateIndex >= 0 && statusUpdatedAt && statusUpdatedAt.length > dateIndex) {
      return <p className="date">{moment(statusUpdatedAt[dateIndex]).format(dateFormat)}</p>;
    }
    return null;
  }
  renderStatus = (item, idx, currentIndex) => {
    const { t } = this.props;
    const dateComponent = this.renderDate(idx);
    return (
      <div key={idx} className={this.getClassName(item, idx, currentIndex)}>
        <div className={`box ${dateComponent !== null ? 'between' : ''}`}>
          <p>{t(item.text)}</p>
          {dateComponent}
        </div>
        <div className="dot" />
      </div>
    );
  }
  render() {
    const { type } = this.props;
    const currentIndex = this.getCurrentIndex();
    const statuses = type === TYPE_CASE_LA ? LAWYER_LA_STATUS_MILESTONES : LAWYER_SPA_STATUS_MILESTONES;
    return (
      <Segment basic className={`CaseStatusMilestone ${type}`}>
        {
          statuses.map((item, idx) => this.renderStatus(item, idx, currentIndex))
        }
      </Segment>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.constants)(CaseStatusMilestone);



// WEBPACK FOOTER //
// ./src/containers/Lawyer/CaseStatusMilestone.jsx